import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { LibraryCategoryEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class LibraryCategorySocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    libraryCategoryCreated$() {
        return this.socketService.receiveMessageObserver(LibraryCategoryEvents.LIBRARY_CATEGORY_CREATED);
    }

    libraryCategoryUpdated$() {
        return this.socketService.receiveMessageObserver(LibraryCategoryEvents.LIBRARY_CATEGORY_UPDATED);
    }

    libraryCategoryDeleted$() {
        return this.socketService.receiveMessageObserver(LibraryCategoryEvents.LIBRARY_CATEGORY_DELETED);
    }
}
